import { keyringProcessByFile2 } from './private/keyringPostProcess2.js';

export const keyringProcess = async ({
  product,
  cutting_line_svg_file,
  makePrintablePNGFile,
  makeThumbnailPNGFile,
  hook_position_ratio,
  // original_svg_file_name,
}) => {
  await keyringProcessByFile2({
    product,
    cutting_line_svg_file,
    makePrintablePNGFile,
    makeThumbnailPNGFile,
    hook_position_ratio,
    // original_svg_file_name,
  });
};
